import React, { useState, useEffect } from 'react';
import { Form, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { ILangDataList } from 'utils/types/common';
import { IComingProps } from 'utils/types/operationTypes';
import { comingSoonApi } from 'apis/operation/comingsoonApis';
import DefaultButton from 'components/button/DefaultButton';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import DefaultLayout from 'components/layout/DefaultLayout';
import InputFlexBox from 'components/container/InputFlexBox';
import InputWrappingBox from 'components/container/InputWrappingBox';
import LocalizingInputForm from 'components/form/LocalizingInputForm';
import fetchLocalizingInput from 'hooks/fetchLocalizingInput';
import RangeDatePicker from 'components/input/RangeDatePicker';
import UtcTimer from 'components/etc/UtcTimer';
import DropZoneImage from 'components/dropzoneUpload/DropZoneImage';
import CurrentImgTag from 'components/etc/CurrentImgTag';
import DefaultRadio from 'components/input/DefaultRadio';
import { PublicState } from 'utils/constant';
/**
 * * 운영 관리 - 커밍순 관리 등록 & 수정
 */

const ComingSoonInputPage = () => {
  const { comingId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const dateFormat = 'YYYY-MM-DD HH:mm:00';
  const today = dayjs().format(dateFormat);

  const [file, setFile] = useState(null);
  const [langList, setLangList] = useState<ILangDataList[]>();
  const [detailData, setDetailData] = useState<IComingProps>();

  /// 다국어 인풋 핸들링
  const handleLocalInputChange = (e) => {
    const { name, value, id } = e.target;
    // console.log(newLocalizingData?.localValue);
    setLangList(
      langList?.map((v) => (v.lang === id ? { ...v, [name]: value } : v)),
    );
  };

  /// 인풋 이벤트 - 공개여부
  const handleInputChange = (e: any) => {
    const { name, value } = e.target;

    setDetailData({ ...detailData!, [name]: value });
  };

  /// 공개 날짜 변경
  const handleDateChange = (dates, dateStrings) => {
    // console.log(dates);
    if (!dates) {
      setDetailData({
        ...detailData!,
        from_date: `${today}`,
        to_date: `${today}`,
      });
      return;
    }
    setDetailData({
      ...detailData!,
      from_date: `${dateStrings[0]}`,
      to_date: `${dateStrings[1]}`,
    });
  };

  /// 데이터 불러오기
  const fetchDetailData = async () => {
    const res = await comingSoonApi.detail(comingId);
    if (res.detail?.length <= 0) {
      setDetailData({
        ...detailData!,
        title: '',
        image_url: '',
        from_date: today,
        to_date: today,
        is_public: 0,
      });
    } else {
      setDetailData(res.detail[0]);
    }
    fetchLocalizingInput(res?.langList, setLangList);
  };
  const handleSubmit = async () => {
    console.log(detailData);
    console.log(langList);
    console.log(comingId);

    const formData = new FormData();
    formData.append('comming_id', comingId!);
    formData.append('from_date', detailData!.from_date!);
    formData.append('to_date', detailData!.to_date!);
    formData.append('is_public', String(detailData?.is_public));
    formData.append('langList', JSON.stringify(langList));
    formData.append('uploadFile', file!);
    const res = await comingSoonApi.update(formData);
    console.log(res);
    if (res !== false) {
      message.success('커밍순 데이터가 등록되었습니다.');
    }
  };

  /// 이미지 태그 닫기
  const handleCloseCurrentImg = () => {
    setDetailData({ ...detailData!, image_url: '' });
  };

  const handleGoBack = () => {
    setFile(null);
    setLangList([]);
    form.resetFields();
    navigate(-1);
  };
  useEffect(() => {
    fetchDetailData().catch(console.log);
  }, []);

  const publicState = PublicState();
  return (
    <DefaultLayout>
      <SubmitFlexBox>
        <>
          <DefaultButton
            onClick={handleGoBack}
            style={{ marginRight: '1rem' }}
            typename='sub'
          >
            목록보기
          </DefaultButton>
          <DefaultButton onClick={handleSubmit}>저장하기</DefaultButton>
        </>
      </SubmitFlexBox>
      <InputFlexBox>
        <InputWrappingBox left>
          <LocalizingInputForm
            langList={langList}
            onChange={handleLocalInputChange}
          />
        </InputWrappingBox>
        <InputWrappingBox>
          <DefaultRadio
            title='공개 여부'
            name='is_public'
            optionList={publicState}
            defaultValue={detailData?.is_public}
            onChange={handleInputChange}
            style={{ marginBottom: '1rem' }}
          />
          {/* <ToggleButton
            title="공개 여부"
            name="is_public"
            onChange={handleInputChange}
            checked={detailData?.is_public === 1 ? true : false}
          /> */}
          <RangeDatePicker
            title='게시 기간'
            format={dateFormat}
            showTime={true}
            value={[
              dayjs(detailData?.from_date, dateFormat),
              dayjs(detailData?.to_date, dateFormat),
            ]}
            ranges={{
              오늘: [dayjs(), dayjs()],
              이번주: [dayjs().startOf(today as any), dayjs().endOf('week')],
              이번달: [dayjs().startOf(today as any), dayjs().endOf('month')],
            }}
            onChange={handleDateChange}
            style={{ width: '100%' }}
          />
          <UtcTimer
            onGrayBox={true}
            startDate={detailData?.from_date}
            endDate={detailData?.to_date}
            style={{
              marginTop: '0.2rem',
              marginBottom: '2rem',
            }}
          />
          <Form form={form}>
            <Form.Item name='uploadFile'>
              {detailData?.image_url === '' ? (
                <DropZoneImage setFile={setFile} />
              ) : (
                <CurrentImgTag
                  src={detailData?.image_url}
                  text={detailData?.image_name}
                  onClose={handleCloseCurrentImg}
                />
              )}
            </Form.Item>
          </Form>
        </InputWrappingBox>
      </InputFlexBox>
    </DefaultLayout>
  );
};

export default ComingSoonInputPage;
